var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BrToolBar',{attrs:{"configFilter":_vm.configFilter,"labelTextField":_vm.labelTextField,"addlFilter":_vm.addlFilter},on:{"search":_vm.buscar}},[_c('BrModalCadastro')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }